export const CHANGE_FISHX_LANGUAGE = 'CHANGE_FISHX_LANGUAGE';

export { default as getInitLocale } from './getInitLocale';
export { default as init } from './init';
export { default as i18n } from './get';
export { default as setLang } from './setlang';
export { default as onEvent } from './onEvent';
export { default as removeEvent } from './removeEvent';
export { default as FormattedMessage } from './FormattedMessage';
export { default as Locale } from './Locale';
